import React, { useState } from 'react';
import { FormattedHTMLMessage, InjectedIntl, injectIntl } from 'react-intl';
import {
    getSafe,
    InputSelectComponent,
    InputTextComponent,
} from '@sheerid/jslib';
import { MajorChoice } from '../../../lib/types/types';
import { MajorEnum } from '../../../lib/types/runtimeTypes';

interface FormFieldComponentProps {
    intl: InjectedIntl;
    value: any;
    onChange: Function;
    isErrored?: boolean;
    placeholder?: string;
}

const AreaOfStudy = ({
    intl,
    value,
    isErrored,
    onChange,
    placeholder = '',
}: FormFieldComponentProps) => {
    const [otherInputValue, setOtherInputValue] = useState('');
    const [majorChoice, setMajorChoice] = useState({ value, label: '' });

    const getMajorOptions = () => {
        const options: MajorChoice[] = [];

        Object.values(MajorEnum).map(major => options.push({
            value: major,
            label: intl.formatMessage({ id: `majorOptions.${major}`, defaultMessage: `${major}` }),
        }));
        return options;
    };

    const majorOptions: MajorChoice[] = getMajorOptions();

    return (
        <div className="sid-field sid-area-of-study">
            <div className="sid-l-space-top-md" />
            <label htmlFor="area-of-study">
                <div className={`sid-field__label sid-field__label--required sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                    <FormattedHTMLMessage
                        id="areaOfStudy"
                        defaultMessage="Area of Study"
                    />
                </div>
            </label>
            <InputSelectComponent
                isRequired
                fieldId="area-of-study"
                inputId="area-of-study"
                options={majorOptions}
                value={majorChoice}
                onChange={(major: MajorChoice) => {
                    if (major && getSafe(() => major.value) !== MajorEnum.OTHER) {
                        onChange(major.label);
                        setOtherInputValue('');
                    } else {
                        onChange('');
                    }
                    setMajorChoice(major || { value: '', label: '' });
                }}
                placeholder={
                    intl.formatMessage({
                        id: 'areaOfStudy',
                        defaultMessage: 'Area of Study',
                    })
                }
                isErrored={isErrored}
            />
            {
                majorChoice.value === MajorEnum.OTHER ? (
                    <InputTextComponent
                        id="other-text-input"
                        isErrored={isErrored as boolean}
                        onChange={(e: any) => {
                            onChange(e.target.value);
                            setOtherInputValue(e.target.value);
                        }}
                        placeholder={intl.formatMessage({ id: 'otherInputPlaceholder', defaultMessage: 'Fill in area of study not listed above' })}
                        refId="otherTextInput"
                        value={otherInputValue}
                    />
                ) : null
            }

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidAreaOfStudy"
                            defaultMessage="Invalid area of study"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export const AreaOfStudyComponent = injectIntl(AreaOfStudy);
